import { render, staticRenderFns } from "./PrivilegeCategory.vue?vue&type=template&id=5bc4204c&scoped=true&"
import script from "./PrivilegeCategory.vue?vue&type=script&lang=js&"
export * from "./PrivilegeCategory.vue?vue&type=script&lang=js&"
import style0 from "./PrivilegeCategory.vue?vue&type=style&index=0&id=5bc4204c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc4204c",
  null
  
)

export default component.exports